import { OrganizationsPage as Organizations } from '../pages';
import { WithRouteData } from '../render-routes';

export const OrganizationsPage = () => {
  return <Organizations />;
};

export default WithRouteData(OrganizationsPage);
